import type { ConversationType } from './types'

export const SERIES_CHATS_CLOSE_AFTER_DAYS = 30
export const CONVERSATION_EDIT_ALLOWED_MINUTES = 60

export const CONVERSATION_TYPE_TO_LABEL: Record<ConversationType, string> = {
  direct: 'Direct message conversation',
  'one-on-one-request': '1:1 session request conversation',
  'session-request': 'Session request conversation',
  'session-direct': 'Session conversation between tutor and learner',
  'session-group': 'Session group conversation',
  'session-tutors': 'Session tutors conversation',
  'series-direct': 'Series conversation between tutor and learner',
  'series-group': 'Series group conversation',
  'series-tutors': 'Series tutors conversation',
  'series-ai': 'Series AI guide conversation',
  'ai-guide': 'AI guide conversation',
}
